import {
  Box,
  Button,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { FormProvider } from 'react-hook-form';
import Radio from 'common/Radio';

import { TitlesWrapper, StyledFormHelperText, VisibleWrapper } from './styled';
import { useMarketLogic } from './useMarketLogic';
import ImagesContainer from './components/Images';

const MarketMutation = () => {
  const {
    market,
    paramId,
    isLoading,
    methods,
    errors,
    isSuccess,
    isImageViewOpen,
    isButtonLoading,
    imageSrcForAction,
    largeImageMessage,
    setValue,
    setFlowProcess,
    onSubmit,
    register,
    handleSubmit,
    onChangeUpload,
    handleDeleteImage,
  } = useMarketLogic();

  if (isLoading) {
    return <div>Loading</div>
  }

  return (
    <FormProvider {...methods}>
      <Stack
        onSubmit={handleSubmit(onSubmit)}
        component="form"
      >
        <Typography
          variant="h5"
          sx={{ mb: 4 }}
        >
          { paramId ? 'Edit Market' : 'Create New Market'}
        </Typography>

        <TitlesWrapper>
          <TextField
            {...register('name')}
            label="Name"
            error={!!errors.name}
            helperText={errors.name ? 'Name is required' : ''}
          />
        </TitlesWrapper>

        <ImagesContainer
          posibilityToMainImage={false}
          keyUploadedFileList="uploadedFileList"
          keyMainImageUrl="mainImageUrl"
          keyExistingImages="existingImages"
          buttonText="Upload Images"
          setValue={setValue}
          multiple={false}
          handleDeleteImage={handleDeleteImage}
          isImageViewOpen={isImageViewOpen}
          imageSrcForAction={imageSrcForAction}
          setFlowProcess={setFlowProcess}
          onChangeUpload={onChangeUpload}
          helperText="Recommended: 300×300 px or 400×300 px (1:1 or 4:3 ratio).
          Transparent PNG or WebP with margin around logo."
        />

        <VisibleWrapper>
          <Box>
            <Typography>
              Visibility in website
            </Typography>
            <Box>
              <Radio label="Yes" name="visible" canBe />
              <Radio label="No" name="visible" canBe={false} />
            </Box>
          </Box>
        </VisibleWrapper>

        {largeImageMessage && <StyledFormHelperText id="messages">{largeImageMessage}</StyledFormHelperText>}
        <p>{isSuccess}</p>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          sx={{ mt: 1 }}
          disabled={isButtonLoading}
        >
          {paramId ? 'UPDATE' : "CREATE"}
        </Button>
      </Stack>
    </FormProvider>
  );
};

export default MarketMutation;
